import { Directive, Input, Output, EventEmitter, HostListener, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Directive({ selector: '[copy-clipboard]' })
export class CopyClipboardDirective {

  @Input('copy-clipboard')
  public stringToCopy: string|number;

  @Output('copied')
  public copied: EventEmitter<string> = new EventEmitter<string>();

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent): void {

    event.preventDefault();
    if (!this.stringToCopy) { return; }

    const listener = (e: ClipboardEvent) => {
      const clipboard = e.clipboardData || window['clipboardData'];
      clipboard.setData('text', this.stringToCopy.toString());
      e.preventDefault();

      this.copied.emit(this.stringToCopy.toString());
    };

    // trick for Safari browsers. It allows to execCommand('copy') only with selected range
    if (window.hasOwnProperty('safari')) {
      const textArea: HTMLTextAreaElement = this.document.createElement('textArea');
      textArea['value'] = this.stringToCopy as string;
      this.document.body.appendChild(textArea);

      let range, selection;

      range = this.document.createRange();
      range.selectNodeContents(textArea);
      selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      textArea.setSelectionRange(0, 999999);
      this.document.execCommand('copy');
      this.document.body.removeChild(textArea);

    }

    this.document.addEventListener('copy', listener, false);
    this.document.execCommand('copy');
    this.document.removeEventListener('copy', listener, false);
  }

  constructor(@Inject(DOCUMENT) private document: any) {
  }
}
